import { Component, OnInit } from '@angular/core';
import { Router, RouterLink, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { first } from 'rxjs/operators';
import { AuthenticationService } from '../../../core/services/authentication.service';
import { UtilityService } from 'src/app/core/utilities/utility.service';
import { BaseService } from '../../../core/services/base.service';
import { Subscription } from 'rxjs';
import { UserService } from 'src/app/core/services/user.service';
import Swal from 'sweetalert2';
import { AppService } from 'src/app/app.service';
import { PingBshpService } from 'src/app/service/ping-bshp.service';
import { DatePipe } from '@angular/common';
import { NetworkCheckServiceService } from '../network-check-service.service';
import * as CryptoJS from 'crypto-js';
// import { ReCaptchaV3Service } from 'ng-recaptcha';
@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss'],
  providers: [DatePipe]
})
export class LoginPageComponent implements OnInit {
  type = "password";
  key = 'aFQTOXZHdeyvglyp'; // Must match Java key
  loginForm: FormGroup;
  submitted = false;
  loading = false;
  returnUrl: string;
  error = '';
  href: any;
  flag: any;
  email: any;
  password: any;
  rememberMeChecked1: boolean = false;
  rememberMeChecked: boolean = false;
  dashboardList: any = [];
  fcmToken: any;
  deviceId: any;
  loggedInphoneNumber: any;
  holidayhourPopup: boolean = false;
  terminatedErrorMsgRed: boolean=false;
  isIspRatesAcknowledged: boolean = false;
  isPortalAnnouncement: boolean = false;
  isOnline: boolean = true;
  errorMessage="";
  MgaIddropdown: any;
  MgaidData: any;
  returnTest: any;
  isBankingInfoAvailable: boolean = false;
  isSINInfoAvailable: boolean = false;
  phoneclick: boolean=false;
  otpclick: boolean=false;
  otpMFA:any;
  otp: string[] = ['', '', '', '', '', ''];
  otpArray = new Array(6);
  minutes: number = 3;
  seconds: number = 0;
  timer1: any;
  requestSINHistory: any[];
  emailerror: any;
  currentYear: number;
  constructor(private router: Router,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private utility: UtilityService, private baseservice: BaseService, public user: UserService, private appService: AppService, private pingService: PingBshpService, private DatePipe: DatePipe,private networkStatusService: NetworkCheckServiceService) {
    // redirect to home if already logged in
    if (this.authenticationService.userValue) {
      this.router.navigate(['/']);
    }
  }
  form: FormGroup;
  private subscription: Subscription;
  ngOnInit(): void {
    this.currentYear = new Date().getFullYear();
    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],

    });
    this.href = this.router.url;
    var name = this.href.split('/')[2]
    this.router.navigateByUrl(name);

    //this.authenticationService.logout();
    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    this.returnTest = this.returnUrl;
    console.log(this.returnUrl)
    if (this.returnUrl == "/dashboard/dashboard-mga") {
      sessionStorage.setItem('selectedMgaIdDoc', 'false');
      sessionStorage.setItem('selectedMgaIdDocCheck', 'true');
      sessionStorage.setItem('selectedMgaIdDocDeactivated', 'false');
    }
    

    this.email = localStorage.getItem('email');
    this.password = localStorage.getItem('pass');
    this.fcmToken = localStorage.getItem('fcmToken');
    if (this.email != null && this.password != null) {
      this.setValueOfTextbox();
      this.rememberMeChecked1 = true;

    }
    this.email = localStorage.getItem('email');
    this.password = localStorage.getItem('pass');
    if(this.email != null && this.password && (this.returnTest == '/' || this.returnTest!==null)){
      this.loginForm.controls.email.setValue(this.email);
      this.loginForm.controls.password.setValue(this.password);
      this.onSubmit();
    }
  }
  //easy access to form fields
  get f() {
    return this.loginForm.controls;
  }

  setValueOfTextbox() {
    this.loginForm.controls.email.setValue(this.email);
    this.loginForm.controls.password.setValue(this.password);
  }

  onSubmit() {
    if(this.emailerror!="Please enter valid Email"){
    // sessionStorage.setItem('loginAttempted', 'true');
    // sessionStorage.removeItem('loginURLAttempted');
    this.networkStatusService.getNetworkStatus().subscribe((status: boolean) => {
      this.isOnline = status;
    });
    this.submitted = true;
    this.error = "";
    // if(this.loginForm.invalid){
    //         return;
    //     }
    if (!this.isOnline) {
      // Show an error message if no internet connection
      this.errorMessage = 'Please check your Internet Connection.';
    } else {
      this.errorMessage = ''; 
    }
    this.loading = true;
    var flagvalid = true;
    //if(this.allowUser == true){
    //sessionStorage.clear();
     if(this.checkForCaptcha==false){
      this.error = "To proceed with login, please select the box to confirm you are not a robot."
      flagvalid =false
     }
//    this.recaptchaV3Service.execute('submit_form').subscribe((token: string) => {
//       const formData = {
//         ...this.loginForm.value,
//         recaptchaToken: token,
//       };
//        console.log('Form data to submit:', formData);
// this.user.getV3RecaptchaVerification(formData.recaptchaToken).subscribe((data:any) =>{
//      debugger
//     if(data.success==true) {
this.flag =true
    if (flagvalid == true &&this.f.email.value != "" && this.f.password.value != "") {
      var encryptedemail=this.encrypt(this.f.email.value)
var encryptedpass=this.encrypt(this.f.password.value)
// this.phoneclick=true
      this.authenticationService.login(encryptedemail, encryptedpass, this.fcmToken, this.deviceId)
        .pipe(first())
        .subscribe(
          data => {
            localStorage.setItem('email', this.f.email.value);
            localStorage.setItem('pass', this.f.password.value);
            localStorage.setItem('fcmToken', this.fcmToken);
            this.pingService.lastPing = new Date();
            // this.isIspRatesAcknowledged=data?.userProfile?.isIspRatesAcknowledged
            // this.isPortalAnnouncement=data?.userProfile?.isPortalAnnouncement
            this.isSINInfoAvailable=data?.userProfile?.isSINInfoAvailable
            this.isBankingInfoAvailable=data?.userProfile?.isBankingInfoAvailable
            localStorage.setItem('isSINInfoAvailable', JSON.stringify(this.isSINInfoAvailable));
            localStorage.setItem('isBankingInfoAvailable', JSON.stringify(this.isBankingInfoAvailable));
            const currentDate = new Date();
            if (currentDate.getDate() >= 10) {
              if (data?.userProfile?.brokerAcceptStatementDate !== null) {                
                 const prevDate = this.DatePipe.transform(data?.userProfile?.brokerAcceptStatementDate, 'yyyy-MM-dd');
                 const prevDate1 = new Date(prevDate);
                // const newcurrentDate = this.DatePipe.transform(currentDate, 'yyyy-MM-dd');
                if (prevDate1.getMonth() < currentDate.getMonth()) {
                  
                  this.holidayhourPopup = true
                }
                else {
                  this.holidayhourPopup = false
                }
              }
              else {
                this.holidayhourPopup = true
              }
            }


            if (data?.userProfile?.isPasswordExpired == true) {
              sessionStorage.setItem("loginUserEmail", this.f.email.value)
              this.router.navigate(['/change-old-password']);
            }
            else {
              if (data?.success == false) {

                if (data?.data?.isGoToChangePasswordScreen == true) {
                  sessionStorage.setItem("loginUserEmail", this.f.email.value)
                  sessionStorage.setItem("isGoToChangePasswordScreen", data?.data?.isGoToChangePasswordScreen)

                  this.router.navigate(['/set-new-password']);
                }
                else {
                  this.error = data?.data
                  if(this.error.includes("Your account has been locked out for 10 minutes due to 3 failed login attempts"))
                  {
                    this.start(10)
                  }
                  else if(this.error.includes("Your account has been locked out for 1 hour due to 6 failed login attempts")){
                    this.start(60)
                  }
                  else{
                    this.stop()
                  }
                }
              }
              else if(data?.userProfile?.leadStatus == "Terminated") {
                this.terminatedErrorMsgRed = true;
              }
              else {
                this.appService.setUserLoggedIn(true);
                localStorage.setItem('currentToken', JSON.stringify(data.accessToken));
                this.flag = sessionStorage.getItem('flag');
                if (this.flag == "true") {
                  if (data.firstTime) {
                    this.router.navigateByUrl('/home/steps-status');
                  } else {
                    this.appService.setUserLoggedIn(true);
                    // this.router.navigateByUrl('/dashboard/personal-info');}
                    sessionStorage.setItem("leadEmailInfo", JSON.stringify(data.userProfile.email));
                    sessionStorage.setItem("loggedInphoneNumber", JSON.stringify(data.userProfile.phoneNumber))
                    this.getDashboard();
                  }
                } else if (this.flag == "false") {
                  this.error = "Please check your email id and password"
                  this.loading = false;
                } else {
                  this.error = "Please check your email and password!"
                  this.loading = false;
                }
              }
            }
            //debugger
          
          }, error => {
            this.error = "Please check your email and password!"
            this.loading = false;
          }, () => { });
    }
    else {
      if(this.checkForCaptcha==false){
        this.error = "To proceed with login, please select the box to confirm you are not a robot."  
       }
       else{
      this.error="Please enter Username / Password";
       }
    }
    //   }
    //  else{
    // // this.error="reCaptcha Verification Failed";
    //  }
    // },error=>{{
    // }},()=>{});
      
    // });
    // }
    // else{
    //   Swal.fire('Please Check the Travelance Privacy Policy Checkbox to Continue')
    // }
  }
  }
  public goToHome() {
    //this.router.navigate(['/forgot-password']);
    this.router.navigate(['/dashboard']);

  }
  mgaName: any;
  getDashboard() {
    this.user.getDashboardData().pipe()
      .subscribe(
        data => {
          this.MgaidData=data.data.leads.agencyMgaId;
          if(this.MgaIddropdown == null || this.MgaIddropdown == undefined){
            this.MgaIddropdown=this.MgaidData;
            sessionStorage.setItem('MgaIddropdown', this.MgaIddropdown);
          }else{
            this.MgaIddropdown=sessionStorage.getItem('MgaIddropdown');
          }
          this.dashboardList = data.data;
          sessionStorage.setItem('leadId', data.data.leads.leadId)
          this.DocmoreInfoReq(data.data.leads.leadId);
          this.requestedSINHistory(data.data.leads.leadId)
          sessionStorage.setItem('agencyId', data.data.leads.agencyId)
          sessionStorage.setItem('leadtype', this.dashboardList.leads.type)
          sessionStorage.setItem('leadStatus', this.dashboardList.leads.leadStatus)
          sessionStorage.setItem('commitionToOfLead', this.dashboardList.leads.commitionTo);
          sessionStorage.setItem('mgaId',data.data.leads.agencyMgaId);
          this.mgaName = data.data.leads.agencyMgaName;
          if (this.dashboardList.leads.type == "Office Admin Staff") {
            this.getLeadAgentsCodes();
          }
          ////
          sessionStorage.setItem('stagesViews', JSON.stringify(this.dashboardList.leads.stagesViews))
          //  this.dashboardList.leads.type=="MGA Admin" &&
          // if(this.dashboardList.leads.type == "Office Admin Staff" || this.dashboardList.leads.leadStatus!='Activated'){
          //       Swal.fire({
          //         title: 'Notice',
          //         text: "Please note, due to year-end closing, partnership requests received between December 16, 2022, and January 9, 2023, will be processed starting January 10, 2022, in the order they were received.",
          //         confirmButtonColor: '#2778c4 !important;',
          //         cancelButtonColor: '#d33',
          //         confirmButtonText: 'Continue to Sign In'
          //       }).then((result) => {
          //         if (result.isConfirmed) {
          //             if(this.dashboardList.leads.stagesViews[0].isCompleted === true &&
          //                 this.dashboardList.leads.stagesViews[0].isApproved === true   &&
          //              this.dashboardList.leads.stagesViews[1].isCompleted === true &&
          //                 this.dashboardList.leads.stagesViews[1].isApproved === true   &&
          //              this.dashboardList.leads.stagesViews[2].isCompleted === true &&
          //                 this.dashboardList.leads.stagesViews[2].isApproved === true   &&
          //             this.dashboardList.leads.stagesViews[3].isCompleted === true &&
          //                 this.dashboardList.leads.stagesViews[3].isApproved === true)
          //                 {
          //                  this.router.navigate(['/activated']);
          //            }
          //            else{
          //                  if (this.dashboardList.leads.stagesViews[0].isCompleted === true && this.dashboardList.leads.stagesViews[0].isApproved === false) {
          //                    this.router.navigate(['/dashboard/personal-info']);
          //                  }
          //          else if (this.dashboardList.leads.stagesViews[1].isCompleted === true && this.dashboardList.leads.stagesViews[1].isApproved === false) {
          //          this.router.navigate(['/dashboard/upload-documents']);
          //                  }
          //                  else if (this.dashboardList.leads.stagesViews[2].isCompleted === true && this.dashboardList.leads.stagesViews[2].isApproved === false) {
          //          this.router.navigate(['/dashboard/contract-sign']);
          //                  }
          //                  else if (this.dashboardList.leads.stagesViews[3].isCompleted === true && this.dashboardList.leads.stagesViews[3].isApproved === false) {
          //          this.router.navigate(['/dashboard/online-training']);
          //                  }
          //          else{
          //            this.router.navigate(['/dashboard/personal-info']);
          //          }
          //            }
          //          }
          //       })
          //     }
          //     else{
          if (this.dashboardList.leads.stagesViews[0].isCompleted === true &&
            this.dashboardList.leads.stagesViews[0].isApproved === true &&
            this.dashboardList.leads.stagesViews[1].isCompleted === true &&
            this.dashboardList.leads.stagesViews[1].isApproved === true &&
            this.dashboardList.leads.stagesViews[2].isCompleted === true &&
            this.dashboardList.leads.stagesViews[2].isApproved === true &&
            this.dashboardList.leads.stagesViews[3].isCompleted === true &&
            this.dashboardList.leads.stagesViews[3].isApproved === true) {
            if (this.dashboardList.leads.leadStatus == "Activated") {
              //debugger
              localStorage.setItem('holidayhourPopup', JSON.stringify(this.holidayhourPopup));
              localStorage.setItem('pricePopup', JSON.stringify(this.isIspRatesAcknowledged));
              localStorage.setItem('PortalAnnouncement', JSON.stringify(this.isPortalAnnouncement));             
            }
            // sessionStorage.setItem("showPopupEmail",JSON.stringify(true))
            // localStorage.setItem('PortalAnnouncement', JSON.stringify(true));
            sessionStorage.setItem("showMobileResponsivePopup", JSON.stringify(true))
            this.router.navigate(['/activated']);
          }
          else {
            if (this.dashboardList.leads.leadStatus !== "Activated" && this.dashboardList.leads.leadStatus !== "Deactivated"){
            // this.DocmoreInfoReq(data.data.leads.leadId);
            if (this.dashboardList.leads.stagesViews[0].isCompleted === true && this.dashboardList.leads.stagesViews[0].isApproved === false) {
              this.router.navigate(['/dashboard/personal-info']);
            }
            else if (this.dashboardList.leads.stagesViews[1].isCompleted === true && this.dashboardList.leads.stagesViews[1].isApproved === false) {
              this.router.navigate(['/dashboard/upload-documents']);
            }
            else if (this.dashboardList.leads.stagesViews[2].isCompleted === true && this.dashboardList.leads.stagesViews[2].isApproved === false) {
              this.router.navigate(['/dashboard/contract-sign']);
            }
            else if (this.dashboardList.leads.stagesViews[3].isCompleted === true && this.dashboardList.leads.stagesViews[3].isApproved === false) {
              this.router.navigate(['/dashboard/online-training']);
            }
            else {
              this.router.navigate(['/dashboard/personal-info']);
            }
          }
            else{
              if (this.dashboardList.leads.leadStatus == "Activated") {
                //debugger
                localStorage.setItem('holidayhourPopup', JSON.stringify(this.holidayhourPopup));
                localStorage.setItem('pricePopup', JSON.stringify(this.isIspRatesAcknowledged));
                localStorage.setItem('PortalAnnouncement', JSON.stringify(this.isPortalAnnouncement));             
              }
              // sessionStorage.setItem("showPopupEmail",JSON.stringify(true))
              // localStorage.setItem('PortalAnnouncement', JSON.stringify(true));
              sessionStorage.setItem("showMobileResponsivePopup", JSON.stringify(true))
              this.router.navigate(['/activated']);
            }
          }
          // }
        }, error => {

          if (error.status == 400 || error.status == 417) {
            this.error = error.error.data;
          }
          else {
            this.error = "Something went wrong. Please refresh the browser and try again.";
          }
        }, () => { });
  }

  show = false;
  toggleShow() {
    this.show = !this.show;
    if (this.show) {
      this.type = "text";
    }
    else {
      this.type = "password";
    }
  }
  rememberMe(data) {
    this.rememberMeChecked = data.target.checked;
    if (this.rememberMeChecked == true) {
      sessionStorage.setItem('username1', this.f.email.value)
      // sessionStorage.setItem('password', this.f.password.value)
    }
    else {
      sessionStorage.clear();

    }
  }
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  // onSelected(data){
  //     
  //     var checkFlag = data.target.checked;
  //     if(checkFlag == true){
  //       this.allowUser = true;

  //     }
  //     else{
  //       this.allowUser = false;
  //     }
  //   }
  agentcodedata = [];
  leadId: any;
  getLeadAgentsCodes() {
    this.leadId = sessionStorage.getItem('leadId');
    this.user.getLeadAgentsCodes(this.leadId).pipe()
      .subscribe(
        data => {
          this.agentcodedata = [];
          if(this.dashboardList.leads.type =="Office Admin Staff" && data.data.agentCodes.length==0)
            {
              this.router.navigate(['/dashboard/dashboard-mga']);
            }
            else{
          for (let i = 0; i < data.data.agentCodes.length; i++) {
            if (data.data.agentCodes[i].agentCode.toLowerCase().indexOf('ovr') > -1) {
              this.agentcodedata.push(data.data.agentCodes[i])
              sessionStorage.setItem('checkOVRInAgencyCode', 'true');
            }
          }
        }
        }, error => {
        }, () => { });
  }
  DocmoreInfoReq(leadId) {

    this.user.DocmoreInfoReq(leadId).pipe()
      .subscribe(
        data => {

          console.log(data.data);
          sessionStorage.setItem('DocmoreInfoReq', data.data)
        }, error => {
        }, () => { });
  }
  display: any;
  public timerInterval: any;
  showTimer:boolean=false
  start(time) {
    
    this.showTimer=true
    clearInterval(this.timerInterval);
    this.timer(time);
  }
  stop() {
    this.showTimer=false
    clearInterval(this.timerInterval);
  }
  timer(minutes: number) {
    let seconds: number = minutes * 60;
    let startTime: number = Date.now();
  
    const updateTimer = () => {
      let elapsedTime: number = Date.now() - startTime;
      let remainingSeconds: number = Math.max(0, seconds - Math.floor(elapsedTime / 1000));
  
      let minutesDisplay: string = String(Math.floor(remainingSeconds / 60)).padStart(2, '0');
      let secondsDisplay: string = String(remainingSeconds % 60).padStart(2, '0');
  
      this.display = `${minutesDisplay}:${secondsDisplay}`;
  
      if (remainingSeconds > 0) {
        window.requestAnimationFrame(updateTimer);
      } else {
        this.showTimer=false
        console.log('finished');
      }
    };
  
    updateTimer();
  }
  checkForCaptcha:boolean=false;
resolved(captchaResponse: any) {
  //debugger
  if(captchaResponse==null){
    this.checkForCaptcha=false;
  }else{
    this.checkForCaptcha=true;
    this.error = "";
  }
}
encrypt(value: string): string {
  const key = CryptoJS.enc.Utf8.parse(this.key);
  const encrypted = CryptoJS.AES.encrypt(value, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.toString();
}

requestedSINHistory(leadId){
  this.requestSINHistory=[]
  this.user.getLicenseRequestCall(leadId,'SIN').pipe()
  .subscribe(
      data => {
         
        if(data.data!="Request Not Found."){
          // this.hideLastRequestedDateSIN=true
          sessionStorage.setItem('sinRequested', JSON.stringify(data.data))
          this.requestSINHistory=data.data;
        //   for(let i=0;i<this.requestHistory?.length;i++){
        //   if(this.requestHistory[i].isRequestCompleted==false){
        //     this.hideLastRequestedDate=true;
        //   }
        // }
          // this.lastRequestedDateSIN=this.requestSINHistory[0]?.createdAt;
          // this.lastRequestedDateSINBy=this.requestSINHistory[0]?.requestedBy;
        }
        if(data.data=="Request Not Found."){
          // this.hideLastRequestedDateSIN=false;
        }
      },error=>{
        // this.hideLastRequestedDateSIN=false;
          },()=>{});
  }
  emailCheck(){
  
         this.emailerror=""
          var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!re.test(this.f.email.value.toLowerCase())) {
          this.emailerror="Please enter valid Email"
        //alert("please enter valid email");
        }
      }
}
